import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class DateFixInterceptor implements HttpInterceptor {
  private isoDateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d*)?Z$/;

  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      map((event) => {
        if (event instanceof HttpResponse) {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          const { body } = event;

          this.convert(body);
        }

        return event;
      }),
    );
  }

  convert(body: any) {
    if (!body) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return body;
    }

    if (typeof body !== 'object') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return body;
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    for (const key of Object.keys(body)) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access
      const value = body[key];
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      const match = this.isoDateFormat.exec(value);
      if (match) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-argument
        body[key] = new Date(value);
      } else if (typeof value === 'object') {
        this.convert(value);
      }
    }
  }
}
